import React from "react";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { restrict } from "../../../../utils/restric/restrict";
import getDecryptedToken from "../../../../api/getDecryptedToken";
import { toColomboYmd } from "../../../../utils/colomboDate";

const paymentDisplayDate = (item: any) =>
  toColomboYmd(item?.paymentDate || item?.createdAt) || "—";

function PaymentTr({ item, handlePrint, handleSms, handleEdit, handleDelete, editable, smsDisabled, smsDisabledMessage }: any) {
  const permit = getDecryptedToken("role");
  const onclick = (item: any) => {
    if (restrict()) return;
    handleEdit(item);
  };

  return (
    <tr className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors group">
      <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-600 dark:text-slate-400">
        {paymentDisplayDate(item)}
      </td>
      <td className="px-4 py-3 whitespace-nowrap">
        <span className="text-sm font-bold text-indigo-600 dark:text-indigo-400">#{item?.invoiceNo}</span>
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-slate-800 dark:text-slate-200 text-right">
        {parseInt(item?.netotal) + parseInt(item?.discount)}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-orange-600 text-right">
        {item?.discount}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-emerald-600 text-right">
        {item?.cash}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-indigo-600 text-right hidden lg:table-cell">
        <div className="inline-flex flex-col items-end leading-tight">
          <span>{item?.card}</span>
          {item?.cardLast4 ? (
            <span className="mt-0.5 text-xs font-medium tracking-wide text-slate-500 dark:text-slate-400">
              ····{item.cardLast4}
            </span>
          ) : null}
        </div>
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-sky-600 text-right hidden lg:table-cell">
        {item?.bankTransfer}
      </td>
      <td className="px-4 py-3 whitespace-nowrap text-center">
        <div className="flex gap-1 justify-center">
          <button
            onClick={() => handlePrint({ paymentid: item?._id, invoiceno: item?.invoiceNo })}
            className="w-8 h-8 rounded-lg bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 flex items-center justify-center hover:bg-indigo-100 dark:hover:bg-indigo-800/50 active:bg-indigo-200 transition-all focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-1 dark:focus:ring-offset-slate-800"
            title="Print"
            aria-label="Print invoice"
          >
            <PrintIcon sx={{ fontSize: 18 }} />
          </button>
          <button
            onClick={() => {
              if (smsDisabled) return;
              handleSms(item);
            }}
            disabled={smsDisabled}
            className="w-8 h-8 rounded-lg bg-emerald-50 dark:bg-emerald-900/40 text-emerald-600 dark:text-emerald-400 flex items-center justify-center hover:bg-emerald-100 dark:hover:bg-emerald-800/50 active:bg-emerald-200 transition-all focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1 dark:focus:ring-offset-slate-800 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-emerald-50"
            title={smsDisabled ? smsDisabledMessage || "SMS tokens finished" : "Send SMS"}
            aria-label="Send SMS"
          >
            <SendIcon sx={{ fontSize: 18 }} />
          </button>
          {editable && (
            <button
              onClick={() => onclick(item)}
              className="w-8 h-8 rounded-lg bg-amber-50 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center hover:bg-amber-100 dark:hover:bg-amber-800/50 active:bg-amber-200 transition-all focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-1 dark:focus:ring-offset-slate-800"
              title="Edit"
              aria-label="Edit invoice"
            >
              <EditIcon sx={{ fontSize: 18 }} />
            </button>
          )}
          {editable &&permit === "Super Admin" && (
            <button
              onClick={() => handleDelete(item)}
              className="w-8 h-8 rounded-lg bg-red-50 dark:bg-red-900/40 text-red-600 dark:text-red-400 flex items-center justify-center hover:bg-red-100 dark:hover:bg-red-800/50 active:bg-red-200 transition-all focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-1 dark:focus:ring-offset-slate-800"
              title="Delete"
              aria-label="Delete payment"
            >
              <DeleteOutlineIcon sx={{ fontSize: 18 }} />
            </button>
          )}
        </div>
      </td>
    </tr>
  );
}

export default PaymentTr;
